var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeglauLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_746",
    "data-name": "Group 746",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125,
    height: 31.016,
    viewBox: "0 0 125 31.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    width: 125,
    height: 31.016,
    fill: "#f36b23"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M6.805,19.6l-5.968.516A.917.917,0,0,0,0,21.026v9.08a.92.92,0,0,0,.27.656.913.913,0,0,0,.65.255h.01l7.381-.005A.918.918,0,0,0,9,30.687a1.079,1.079,0,0,0,.253-.79L7.792,20.374A.922.922,0,0,0,6.9,19.6a.909.909,0,0,0-.092,0m6.948-3.429-3.477,2.063a.917.917,0,0,0-.417,1.029l3.012,11.017a.97.97,0,0,0,.881.732H27.289a.916.916,0,0,0,.846-.564,1.012,1.012,0,0,0-.2-1.058L14.87,16.314a.921.921,0,0,0-1.117-.141m4.622-5.04-1.987,2.33a.917.917,0,0,0,.132,1.317L36.834,30.82a.92.92,0,0,0,.566.2H71.267a1.022,1.022,0,0,0,.9-.875.917.917,0,0,0-.6-1.019L19.377,10.862a.942.942,0,0,0-.3-.05.915.915,0,0,0-.7.321m2.417-5.169-.535,1.8A.916.916,0,0,0,20.884,8.9L97.6,30.98a.893.893,0,0,0,.252.036h26.235A.917.917,0,0,0,125,30.1l0-11.055a.9.9,0,0,0-.786-.909L21.789,5.317a.99.99,0,0,0-.106-.006.92.92,0,0,0-.889.654M22.283,0a.939.939,0,0,0-.917.911L21.29,2.183a.917.917,0,0,0,.846.946L124.012,10.8l.071,0A.917.917,0,0,0,125,9.886V.918A.917.917,0,0,0,124.083,0Z",
    fill: "#f36b23"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeglauLogo);
export default __webpack_public_path__ + "static/media/BeglauLogo.25d4359750029a86c0c8850a20387704.svg";
export { ForwardRef as ReactComponent };